import {getPercent, getPercentDifference} from 'util/utils';
import {PERCENT, ONE_ELEMENT, INIT_INDEX, DEFAULT_DECIMALS, ZERO} from 'util/constants';
import {
    TAG_CLOUD_BILLING_ACCOUNTS,
    TAG_CLOUD_BILLING_SERVICES,
    TAG_CLOUD_BILLING_VENDORS,
    TAG_CLOUD_BILLING_REGIONS,
    TAG_CLOUD_BILLING_PROJECTS
} from 'modules/ui';


const DIARY = 'daily';
const MONTHLY = 'monthly';
const ANNUAL = 'annual';
const YEAR_TO_DATE = 'year_to_date';
const LAST_12_MONTHS = 'last12m';

export const CHART_OPTIONS = {
    DIARY,
    MONTHLY,
    ANNUAL,
    YEAR_TO_DATE,
    LAST_12_MONTHS
};

export const DEFAULT_AMOUNT = 0;


const PROJECTS = 'cost_center';
const VENDORS = 'vendor';
const SERVICES = 'service';
const REGIONS = 'region';
const ACCOUNTS = 'account';

const SELECT_ALL = 1;
const SELECT_PAGE = 0;
const UNSELECTED_ALL = 2;
const UNSELECTED_PAGE = 3;

export const SELECTION_OPTIONS = {
    SELECT_PAGE,
    SELECT_ALL,
    UNSELECTED_ALL,
    UNSELECTED_PAGE
};

const INCLUDE = 0;
const EXCLUDE = 1;

export const ENTITIES = {
    PROJECTS,
    VENDORS,
    SERVICES,
    REGIONS,
    ACCOUNTS
};

export const TABS = [
    PROJECTS,
    VENDORS,
    SERVICES,
    REGIONS,
    ACCOUNTS
];

export const TYPE_REQUEST = {
    INCLUDE,
    EXCLUDE
};

export const SPENDING_BREAKDOWN_PATH = 'spending-breakdown';

export const addPercentToEntity = (total, entities = []) => entities.map(entity => ({
    ...entity,
    percent:          Math.round(getPercent(total, entity.spendingSelectedMonth.toFixed(DEFAULT_DECIMALS)) * PERCENT) / PERCENT,
    formattedPercent: `${Math.round(getPercent(total, entity.spendingSelectedMonth.toFixed(DEFAULT_DECIMALS)) * PERCENT) / PERCENT} %`
}));

export const differenceBetweenMonths = entities => entities.map(entity => {
    const fixedSpendingPreviousMonth = parseFloat(entity.spendingPreviousMonth ? entity.spendingPreviousMonth.toFixed(DEFAULT_DECIMALS) : ZERO);
    const fixedSpendingSelectedMonth = parseFloat(entity.spendingSelectedMonth ? entity.spendingSelectedMonth.toFixed(DEFAULT_DECIMALS) : ZERO);

    const entityResult = getPercentDifference(fixedSpendingPreviousMonth, fixedSpendingSelectedMonth);

    return {
        ...entity,
        difference:          Math.round(entityResult.difference * PERCENT) / PERCENT,
        icon:                entityResult.icon,
        color:               entityResult.color,
        formattedDifference: `${Math.round(entityResult.difference * PERCENT) / PERCENT} %`
    };
});

export const setAllEntitiesChecked = entities => entities.map(entity => ({
    ...entity,
    checked: true
}));

export const setAllEntitiesUnchecked = entities => entities.map(entity => ({
    ...entity,
    checked: false
}));

export const getEntitiesParam = (entities, selected) => {
    if (entities && entities.length) {
        switch (selected) {
        case ENTITIES.ACCOUNTS: {
            return {account: entities};
        } case ENTITIES.REGIONS: {
            return {region: entities};
        } case ENTITIES.PROJECTS: {
            return {cost_center: entities};
        } case ENTITIES.SERVICES: {
            return {product: entities};
        } case ENTITIES.VENDORS: {
            return {vendor: entities};
        } default: return {account: entities};
        }
    }

    return [];
};

export const formatVendor = entities => entities.map(entity => ({
    ...entity,
    vendorIcon: entity.vendor.code.toLowerCase(),
    vendorName: entity.vendor.name
}));

export const addDifference = (entities, totalSpending) => {
    const entitiesPercent = addPercentToEntity(totalSpending, entities);


    const newEntities = differenceBetweenMonths(entitiesPercent);

    const checkedNotaNumberEntities = [];

    newEntities.forEach(item => {
        if (isNaN(item.difference) || item.difference === Infinity) {
            checkedNotaNumberEntities.push({
                ...item,
                formattedDifference: ' ',
                icon:                ' '
            });
        } else {
            checkedNotaNumberEntities.push(item);
        }
    });

    return checkedNotaNumberEntities;
};

export const getTag = entity => {
    switch (entity) {
    case ENTITIES.PROJECTS: {
        return TAG_CLOUD_BILLING_PROJECTS;
    } case ENTITIES.ACCOUNTS: {
        return TAG_CLOUD_BILLING_ACCOUNTS;
    } case ENTITIES.SERVICES: {
        return TAG_CLOUD_BILLING_SERVICES;
    } case ENTITIES.VENDORS: {
        return TAG_CLOUD_BILLING_VENDORS;
    } case ENTITIES.REGIONS: {
        return TAG_CLOUD_BILLING_REGIONS;
    } default: return TAG_CLOUD_BILLING_ACCOUNTS;
    }
};

export const getDefaultNameIfNeeded = (clickedEntities, typeRequest) => {
    const entityName = clickedEntities[INIT_INDEX].alias || clickedEntities[INIT_INDEX].name;
    const totalEntities = clickedEntities.length - ONE_ELEMENT;


    if (clickedEntities.length === ONE_ELEMENT) {
        return entityName;
    }

    return `${entityName} y ${totalEntities} más`;

};



// WEBPACK FOOTER //
// ./src/containers/cloud-billing/utils/utils.js